module.exports = __webpack_public_path__ + "static/media/choithramsRanaBanner.cbc84837.png";